import { render, staticRenderFns } from "./dragAndCopyUpload.vue?vue&type=template&id=87f0336e&"
import script from "./dragAndCopyUpload.vue?vue&type=script&lang=js&"
export * from "./dragAndCopyUpload.vue?vue&type=script&lang=js&"
import style0 from "./dragAndCopyUpload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports